import React from "react";
import classnames from "classnames";
import { useHistory } from "react-router-dom";
import scan_button from "../images/scan-button.svg";

type ScanButtonProps = {
  float?: boolean;
};

export const ScanButton: React.FC<ScanButtonProps> = ({ float }) => {
  const history = useHistory();
  // Stop propagation so a tap on the scan button doesn't ALSO trigger
  // ancestor handlers — specifically the email panel's "open the drawer"
  // click handler, which otherwise causes a visual twitch (drawer slides
  // up while the route is mid-transition to /scan).
  const handleScan = (e: React.MouseEvent) => {
    e.stopPropagation();
    history.push({ pathname: "/scan" });
  };

  return (
    <div className="scan-wrapper">
      <div
        id="camera-btn"
        className={classnames("scan-button", { floating: float })}
        onClick={handleScan}
        role="button"
        aria-roledescription="camera button"
      >
        <img src={scan_button} alt="scan" aria-labelledby="camera-btn" />
      </div>
    </div>
  );
};
